import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { defineMessages, useIntl } from 'react-intl';
// import { Icon } from '@package/icons';

const messages = defineMessages({
  missingRequired: {
    id: 'Fill at least one stat',
    defaultMessage: 'Fill at least one stat',
  },
});

const buildObject = (id, data) => {
  const {
    [`category${id}`]: category = '',
    [`description${id}`]: description = '',
    [`value${id}`]: value = '',
    [`icon${id}`]: icon = '',
    [`style${id}`]: style = '',
  } = data;

  return {
    category: category.trim(),
    description: description.trim(),
    value: value.trim(),
    icon,
    style,
  };
};

const getStats = (data) => {
  return [
    buildObject(1, data),
    buildObject(2, data),
    buildObject(3, data),
  ].filter(
    (stat) =>
      !(!stat.value && !stat.category && !stat.description && !stat.icon),
  );
};

const NumbersBody = (props) => {
  const { data } = props;
  const { title, subtitle, buttonLabel, buttonUrl } = data;
  const intl = useIntl();

  const stats = getStats(data);

  return (
    <div className="block-numbers">
      <div className="ui container">
        {title ? (
          <h2 className="text-center text-pure-0 mt-0 mb-2">{title}</h2>
        ) : null}
        {subtitle ? (
          <p className="text-center text-pure-0 mt-0 mb-2">{subtitle}</p>
        ) : null}

        {!stats.length ? (
          <div>{intl.formatMessage(messages.missingRequired)}</div>
        ) : (
          <ul>
            {stats.map((stat, idx) => (
              <li key={idx}>
                {/* {stat.icon ? (
                  <div className={styles.icon}>
                    <span className={stat.style}>
                      <Icon icon={stat.icon} size={42} />
                    </span>
                  </div>
                ) : null} */}

                {stat.category ? (
                  <div className="cat">{stat.category}</div>
                ) : null}
                {stat.value ? <div className="val">{stat.value}</div> : null}
                {stat.description ? (
                  <div className="label">{stat.description}</div>
                ) : null}
              </li>
            ))}
          </ul>
        )}

        <div className="text-center mt-7">
          {buttonLabel && buttonUrl ? (
            <UniversalLink
              item={{ '@id': buttonUrl }}
              className="br-button secondary dark-mode bg-blue-warm-vivid-80"
            >
              {buttonLabel}
            </UniversalLink>
          ) : null}
        </div>
      </div>
    </div>
  );
};

NumbersBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default NumbersBody;
